import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
export function TrustStrip() {
  const {
    t
  } = useLanguage();
  return <div className="border-b border-petal bg-white" data-id="element-107" data-mp="3h59ilad0pnbo">
      <ul className="no-scrollbar mx-auto flex max-w-7xl snap-x items-center gap-x-8 gap-y-3 overflow-x-auto px-5 py-5 sm:px-8 lg:justify-between" data-id="element-108" data-mp="3h5t0ir2o4bpp">
        {t.home.trust.map(item => <li key={item} className="flex shrink-0 snap-start items-center gap-2 whitespace-nowrap text-sm font-medium text-mauve-deep" data-id="element-109" data-mp="cprj7ybubu1c">
            <CheckIcon className="h-4 w-4 text-champagne" aria-hidden="true" data-id="element-110" data-mp="3y7pjqm28ad8" />
            {item}
          </li>)}
      </ul>
    </div>;
}